// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalLocation_wrapper__VZ03v","button":"ModalLocation_button__3w4hx"};